<template lang="pug">
  #services.custom-container
    .section-title Servicios
    b-breadcrumb.breadcrumb(:items="breadcrumbs")
    ListServices()
</template>
<script>
import ListServices from '../components/service/ListServices';
export default {
  data(){
    return{
      breadcrumbs: [
        {
          text: 'Inicio',
          to: { name: 'Home' }
        },
        {
          text: 'Servicios',
          active:true
        },
      ]
    }
  },
  components: {
    ListServices
  }
}
</script>
